"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
const stitches_config_1 = require("../../../stitches.config");
exports.Divider = (0, stitches_config_1.styled)("div", {
    borderTop: stitches_config_1.borderStyles.solid,
    margin: 0,
    variants: {
        extension: {
            8: {
                margin: "0 -8px",
                "@lg": {
                    margin: "0 -16px",
                },
            },
            16: {
                margin: "0 -16px",
                "@lg": {
                    margin: "0 -24px",
                },
            },
        },
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGl2aWRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL2NvbXBvbmVudHMvQ29tbW9uL19fc3R5bGVzX18vRGl2aWRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw4REFBZ0U7QUFFbkQsUUFBQSxPQUFPLEdBQUcsSUFBQSx3QkFBTSxFQUFDLEtBQUssRUFBRTtJQUNuQyxTQUFTLEVBQUUsOEJBQVksQ0FBQyxLQUFLO0lBQzdCLE1BQU0sRUFBRSxDQUFDO0lBQ1QsUUFBUSxFQUFFO1FBQ1IsU0FBUyxFQUFFO1lBQ1QsQ0FBQyxFQUFFO2dCQUNELE1BQU0sRUFBRSxRQUFRO2dCQUNoQixLQUFLLEVBQUU7b0JBQ0wsTUFBTSxFQUFFLFNBQVM7aUJBQ2xCO2FBQ0Y7WUFDRCxFQUFFLEVBQUU7Z0JBQ0YsTUFBTSxFQUFFLFNBQVM7Z0JBQ2pCLEtBQUssRUFBRTtvQkFDTCxNQUFNLEVBQUUsU0FBUztpQkFDbEI7YUFDRjtTQUNGO0tBQ0Y7Q0FDRixDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBib3JkZXJTdHlsZXMsIHN0eWxlZCB9IGZyb20gXCIuLi8uLi8uLi9zdGl0Y2hlcy5jb25maWdcIjtcblxuZXhwb3J0IGNvbnN0IERpdmlkZXIgPSBzdHlsZWQoXCJkaXZcIiwge1xuICBib3JkZXJUb3A6IGJvcmRlclN0eWxlcy5zb2xpZCxcbiAgbWFyZ2luOiAwLFxuICB2YXJpYW50czoge1xuICAgIGV4dGVuc2lvbjoge1xuICAgICAgODoge1xuICAgICAgICBtYXJnaW46IFwiMCAtOHB4XCIsXG4gICAgICAgIFwiQGxnXCI6IHtcbiAgICAgICAgICBtYXJnaW46IFwiMCAtMTZweFwiLFxuICAgICAgICB9LFxuICAgICAgfSxcbiAgICAgIDE2OiB7XG4gICAgICAgIG1hcmdpbjogXCIwIC0xNnB4XCIsXG4gICAgICAgIFwiQGxnXCI6IHtcbiAgICAgICAgICBtYXJnaW46IFwiMCAtMjRweFwiLFxuICAgICAgICB9LFxuICAgICAgfSxcbiAgICB9LFxuICB9LFxufSk7XG4iXX0=